import { getMenuData } from '@ant-design/pro-layout'
import pathRegexp from 'path-to-regexp'
import omit from 'lodash/omit'

function stripQueryStringAndHashFromPath(url: string) {
    return url.split('#')[0]
}

const getFlatMenus = (menuData = []) => {
    let menus = {}
    menuData.forEach(item => {
        if (!item || !item.key) {
            return
        }
        menus[stripQueryStringAndHashFromPath(item.path || item.key || '/')] = {
            ...item,
        }
        menus[item.key || item.path || '/'] = { ...item }
        if (item.children) {
            menus = { ...menus, ...getFlatMenus(item.children) }
        }
    })
    return menus
}

const getMenuMatches = (flatMenuKeys = [], path, exact) =>
    flatMenuKeys
        .filter(item => {
            if (item === '/' && path === '/') {
                return true
            }
            if (item !== '/' && item !== '/*' && item) {
                const pathKey = stripQueryStringAndHashFromPath(item)
                try {
                    // exact
                    if (exact) {
                        if (pathRegexp(`${pathKey}`).test(path)) {
                            return true
                        }
                    }
                    // /a
                    if (pathRegexp(`${pathKey}`, []).test(path)) {
                        return true
                    }
                    // /a/b/b
                    if (pathRegexp(`${pathKey}/(.*)`).test(path)) {
                        return true
                    }
                } catch (error) {
                    console.error('catchError', error)
                }
            }
            return false
        })
        .sort((a, b) => {
            // 如果完全匹配放到最后面
            if (a === path) {
                return 10
            }
            if (b === path) {
                return -10
            }
            return a.substr(1).split('/').length - b.substr(1).split('/').length
        })

const getMatchMenu = (pathname, menuData, fullKeys, exact) => {
    const flatMenus = getFlatMenus(menuData)

    const flatMenuKeys = Object.keys(flatMenus)

    let menuPathKeys = getMenuMatches(flatMenuKeys, pathname || '/', exact)
    if (!menuPathKeys || menuPathKeys.length < 1) {
        return []
    }
    if (!fullKeys) {
        menuPathKeys = [menuPathKeys[menuPathKeys.length - 1]]
    }
    return menuPathKeys
        .map(menuPathKey => {
            const menuItem = flatMenus[menuPathKey] || {
                pro_layout_parentKeys: '',
                key: '',
            }
            // 去重
            const map = new Map()
            const parentItems = (menuItem.pro_layout_parentKeys || [])
                .map(key => {
                    if (map.has(key)) {
                        return null
                    }
                    map.set(key, true)
                    return flatMenus[key]
                })
                .filter(item => item)
            if (menuItem.key) {
                parentItems.push(menuItem)
            }
            return parentItems
        })
        .flat(1)
}

export const getRouteByLocation = ({ routes, location }) => {
    const { menuData } = getMenuData(routes) || []

    return getMatchMenu(location.pathname || '/', menuData).pop()
}

export const getRouteByNmae = ({ routes, name, parent }) => {
    for (let v of routes) {
        if (v.name === name) {
            return {
                ...v,
                parent,
            }
        }

        if (Array.isArray(v.routes)) {
            const res = getRouteByNmae({ routes: v.routes, name, parent: omit(v, 'routes') })

            if (res) {
                return res
            }
        }
    }
}
